import { styled } from '@mui/material/styles';
import spinner from 'assets/spinner.gif';

const ComponentLoaderWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  zIndex: '2000',
  backgroundColor: '#ffffff',
  opacity: '0.7',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}));

const ScreenLoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  zIndex: '2000',
  display: 'flex',
  top: '50%',
  left: '50%',
  marginTop: '-50px',
  marginLeft: '-50px'
}));

export interface ComponentLoaderProps {
  isLoading: boolean;
}

export const ComponentLoader: React.VFC<ComponentLoaderProps> = (props) => {
  return props.isLoading ? (
    <ComponentLoaderWrapper>
      <img src={spinner} id="loading-spinner" alt="Loading..." width="100" />
    </ComponentLoaderWrapper>
  ) : null;
};

export const ScreenLoader: React.VFC<ComponentLoaderProps> = (props) => {
  return props.isLoading ? (
    <ComponentLoaderWrapper>
      <ScreenLoaderWrapper>
        <img src={spinner} id="loading-spinner" alt="Loading..." width="100" />
      </ScreenLoaderWrapper>
    </ComponentLoaderWrapper>
  ) : null;
};
